import React, { Component } from 'react'
import LoginRota from './Login'
class ComponentName extends Component {
    render() {
        return (
            <div>
                public
            </div>
        )
    }
}


const config = {
    subConfig: [
        LoginRota,
    ],
    route: {
        path: '/public',
        exact: true,
        component: ComponentName,
    },
}


export default config


// WEBPACK FOOTER //
// ./src/routes/public/index.js